// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"284377b9","668":"50e4f898","785":"f36cd29f"}[chunkId] + ".js";
};